import React from "react"
import { useModalContext } from "./ModalContenxtProvider"
import { ModalRegistration, ModalRegistrationSuccess } from "./types"

export const ModalManager = () => {
  const { modalType, isModalOpen } = useModalContext()

  const ModalComponent = () => {
    switch (true) {
      case modalType === "registration":
        return <ModalRegistration />
      case modalType === "registrationSuccess":
        return <ModalRegistrationSuccess />
      default:
        break
    }
  }

  return isModalOpen && <ModalComponent />
}
